import { render, staticRenderFns } from "./FixProduct.vue?vue&type=template&id=3c9b0606"
import script from "./FixProduct.vue?vue&type=script&lang=js"
export * from "./FixProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports